<div class=" mt-4">
     
    <section class="mt-3">
      <div class="">
        <div class="row">
          <div class="col-md-7">
            <div class="card-1">
              <div class="row">
                <div class="col-md-12">
                  <div class="text-center mb-5">
                    <img src="assets/img/new/view-trans.svg" />
                  </div>
                  <div class="text-center">
                    <a class="view-h gary-t">PayOut Batch Details</a>
                  </div> 
  
                    <div class="row pt-5">
                        <div class=" col-md-12">
                            <div class="row mb-3">
  
                                <div class="col-4 p-0"> <label>PayOutBatchId</label> </div>
                                
                                <div class="col-7 p-0 view-text robot"> {{PayOutBatchId}}
                                                                 </div>
                            </div>
                           
                            <div class="row mb-3">
  
                                <div class="col-4 p-0"> <label>MerchantKeyId</label> </div>
                                
                                <div class="col-7 p-0 view-text robot"> {{MerchantKeyId}}</div>
                            </div>
                            <div class="row mb-3">
  
                              <div class="col-4 p-0"> <label>PayoutTransactionId</label> </div>
                              
                              <div class="col-7 p-0 view-text robot"> {{PayoutTransactionId}}</div>
                          </div>
                         
                            <div class="row mb-3">
  
                                <div class="col-4 p-0"> <label> TransactionType</label></div>
                                
                                <div class="col-7 p-0 view-text robot"> {{TransactionType}}</div>
                            </div>
                          
                            <div class="row mb-3">
  
                                <div class="col-4 p-0"> <label>PaymentType </label>  </div>
                                
                                <div class="col-7 p-0 view-text"> {{PaymentType}}</div>
                            </div>
                            <div class="row mb-3">
  
                                <div class="col-4 p-0"><label> TransactionAmount </label>  </div>
                                
                                <div class="col-7 p-0 view-text robot"> {{TransactionAmount}}</div>
                            </div>
                            <!-- <div class="row mb-3">
  
                                <div class="col-4 p-0"> <label> FeeCode </label>  </div>
                                
                                <div class="col-7 p-0 view-text"> {{rows.FeeCode}}</div>
                            </div>
                            <div class="row mb-3">
  
                                <div class="col-4 p-0"> <label> FeeAmount</label>  </div>
                                
                                <div class="col-7 p-0 view-text robot">   {{rows.FeeAmount }}</div>
                            </div>
                            <div class="row mb-3">
  
                                <div class="col-4 p-0"> <label>GSTPercentage</label>  </div>
                                
                                <div class="col-7 p-0 view-text robot"> {{rows.GSTPercentage}}</div>
                            </div>
                            <div class="row mb-3">
  
                                <div class="col-4 p-0"><label> GSTAmount </label>  </div>
                                
                                <div class="col-7 p-0 view-text robot"> {{rows.GSTAmount}}</div>
                            </div>
                            <div class="row mb-3">
  
                                <div class="col-4 p-0"><label>  TotalFeeAmount</label> </div>
                                
                                <div class="col-7 p-0 view-text robot"> {{rows.TotalFeeAmount}}</div>
                            </div>
                            <div class="row mb-3">
  
                                <div class="col-4 p-0"><label> BuyAmount  </label> </div>
                                
                                <div class="col-7 p-0 view-text"> {{rows.BuyAmount}}</div>
                            </div>
                            <div class="row mb-3">
  
                                <div class="col-4 p-0"><label>  UpdatedDatetime </label>  </div>
                                
                                <div class="col-7 p-0 view-text"> {{rows.RecordDateTime | date:'d/M/yy, h:mm a'}}</div>
                            </div>
                            -->
                         
  
  
                            <div class="row m-1 text-right">
                               
                              
                            </div>
                        </div>
                    </div>  
                 
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="text-center">
              <img src="https://fastswiff.com/assets/img/vpos-tour-images/payout/manage-payout.png" class="w-100" alt="">
            </div>
          </div>
        </div>
      </div>
    </section> 
  </div>


 




  


